import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../../../../components/Button/Button';
import ProgressBar from '../../../../components/ProgressBar/ProgressBar';
import Spinner from '../../../../../common/components/Spinner';
import styles from './UploadDropzone.module.scss';
import cx from 'classnames';

const UploadDropzone = ({
    className,
    mainTitle,
    progressTitle,
  waitingForApproval = false,
    onDrop,
    accept = { 'video/*': ['.mp4', '.mov', '.webm', '.wmv', '.avi'] },
    isUploading,
    isProcessingFiles,
    totalProgress = null,
    approxTime = null,
  showErrorMessage,
  maxFiles = 1,
}) => {

    const { t } = useTranslation();

    const containerRef = useRef(null);

    const mediaMatch = window.matchMedia('(max-width: 900px)');
    const [isMobileView] = useState(mediaMatch.matches);
  const [fileNames, setFileNames] = useState([]);

  const handleDrop = useCallback((acceptedFiles, rejectedFiles) => {
    console.log('handleDrop', { acceptedFiles, rejectedFiles, onDrop });
    setFileNames(acceptedFiles.map(file => file.name));
    onDrop(acceptedFiles, rejectedFiles);
  }, [onDrop]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
      onDrop: handleDrop,
        accept,
        disabled: isUploading || isProcessingFiles,
      maxFiles
    });

    useEffect(() => {
        if (isMobileView) {
            containerRef?.current?.click();
        }
    }, []);

    return (
        <div {...getRootProps()} className={cx(styles.dropzoneWrapper, className)}>
            <input {...getInputProps()} accept="video/mp4, video/quicktime, video/webm, video/wmv, video/avi" />
            {isUploading ? (
                <div className={styles.explanationContainer}>
                    {isUploading &&
                        (isProcessingFiles || totalProgress === null ? (
                            <Spinner width="40px" height="40px" size="3px" className={styles.processingSpinner} />
                        ) : (
                            <ProgressBar
                                strokeWidth="5.5"
                                sqSize="40"
                                percentage={Math.round(totalProgress?.percent)}
                                upload={true}
                                className={styles.uploadProgressBar}
                            />
                        ))}
                    <h3 className={styles.header}>{progressTitle}</h3>
                    {totalProgress && totalProgress?.percent < 100 ? (
                        <p className={styles.uploadingText}>
                            {approxTime
                                ? `${totalProgress?.loaded} / ${totalProgress?.total} - ${t('general.editor.aprox_time', {
                                    time: approxTime,
                                })}`
                                : t('clip_organizer.add_modal.calculating')}
                        </p>
                    ) : null}
                </div>
            ) : (
                <div ref={containerRef} className={styles.explanationContainer}>
                    <h3 className={styles.header}>{mainTitle}</h3>
                    <p className={styles.uploadingText}>{t('clip_organizer.add_modal.supported_files')}</p>
              {waitingForApproval && !isUploading && <p className={styles.selectedText}>{t('clip_organizer.add_modal.selected_files_names')} <span className={styles.filesName}>{`'${fileNames.join(', ')}'`}</span></p>}  
                    {isDragActive ? null : (
                        <CustomButton
                  label={isMobileView ? t('clip_organizer.add_modal.browse') : t(waitingForApproval ? 'clip_organizer.add_modal.change_selection' : 'clip_organizer.add_modal.or_browse')}
                            variant="secondary"
                            className={styles.browseBtn}
                        />
                    )}
                    {showErrorMessage && <p className={styles.uploadingErrorText}>{t('clip_organizer.add_modal.error_message')}</p>}
                </div>
            )}
        </div>
    );
}

export default UploadDropzone;